module.exports = __webpack_public_path__ + "static/img/logo-login.6a2e425c.jpg";